import { Component, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { MODULE_DOB_SEX_PAGE } from '@app/core/mixpanel.constants';
import {
  DependentAlreadyRegisteredError,
  NoWhitelistedDependentFoundError,
} from '@app/registration/enterprise/whitelisted-employee-errors';
import { DateInputComponent } from '@app/shared/date-input/date-input.component';
import { RadioInputNgrxComponent } from '@app/shared/radio-input-ngrx/radio-input-ngrx.component';

import { EnterpriseRegistrationAnalyticsService } from '../enterprise-registration-analytics.service';
import { RegistrationStepDirective } from '../registration-step.directive';

@Component({
  selector: 'om-dob-sex-step',
  styleUrls: ['../../../shared/form-input.scss'],
  templateUrl: './dob-sex-step.component.html',
})
export class DobSexStepComponent extends RegistrationStepDirective {
  @ViewChild('dateOfBirth', { static: true }) dateOfBirth: DateInputComponent;
  @ViewChild('sex', { static: true }) sex: RadioInputNgrxComponent;
  @ViewChild('genderDetails') genderDetails: HTMLInputElement;
  @ViewChild('dependentNotFound', { static: true }) dependentNotFound: TemplateRef<any>;
  @ViewChild('dependentRegistered', { static: true }) dependentRegistered: TemplateRef<any>;

  minimumAge: number;
  showGenderDetails = false;
  sexOptions = [
    {
      label: 'Female',
      value: 'female',
    },
    {
      label: 'Male',
      value: 'male',
    },
  ];

  MODULE = MODULE_DOB_SEX_PAGE;
  b2bCompanyId: number;

  constructor(
    public modalService: NgbModal,
    private router: Router,
    private enterpriseRegistrationAnalyticsService: EnterpriseRegistrationAnalyticsService,
  ) {
    super();
  }

  onSubmit() {
    this.submitting = true;
    this.dateOfBirth.markAsTouchedAndDirty();
    this.form.controls.sex.markAsTouched();
    this.form.controls.sex.markAsDirty();
    this.submit.emit(this.form.value);
  }

  showSexError() {
    const control = this.form.controls.sex;
    return control.dirty && control.touched && control.invalid;
  }

  onError(err: Error) {
    this.submitting = false;
    if ((err as DependentAlreadyRegisteredError).dependentAlreadyRegistered) {
      this.modalService.open(this.dependentRegistered);
    } else if ((err as NoWhitelistedDependentFoundError).noWhitelistedDependentFound) {
      this.modalService.open(this.dependentNotFound);
    }
  }

  logIn() {
    this.modalService.dismissAll();
    this.router.navigateByUrl('/login');
  }

  get showMinorError(): boolean {
    const { errors } = this.form.controls.dob;
    return !!errors && !!errors.age && !errors.age.valid;
  }

  trackGenderClick() {
    this.enterpriseRegistrationAnalyticsService.genderClicked({
      module: this.MODULE,
      companyId: this.b2bCompanyId,
    });
  }
}
